import { render, staticRenderFns } from "./PageAnswer.vue?vue&type=template&id=449440c1&scoped=true"
import script from "./PageAnswer.vue?vue&type=script&lang=js"
export * from "./PageAnswer.vue?vue&type=script&lang=js"
import style0 from "./PageAnswer.vue?vue&type=style&index=0&id=449440c1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449440c1",
  null
  
)

export default component.exports